import { Model as ORMModel, attr } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { STORE_VERSION } from '@fedsim/constants'

export class Game extends ORMModel {
  static get fields() {
    return {
      id: attr({ getDefault: () => 1 }),
      dark: attr({ getDefault: () => false }),
      brandIds: attr({ getDefault: () => [] }),
      storeVersion: attr({ getDefault: () => STORE_VERSION }),
      pageId: attr({ getDefault: () => 0 }),
      date: attr({ getDefault: () => new Date() }),
      openAiKey: attr({ getDefault: () => '' }),
      setupEmpty: attr({ getDefault: () => true }),
      setupComplete: attr({ getDefault: () => true }),
      alertOfficeIntro: attr({ getDefault: () => true }),
      alertProductionGuided: attr({ getDefault: () => true }),
      alertLeaguesIntro: attr({ getDefault: () => true }),
      alertOfficeCalendar: attr({ getDefault: () => true }),
      alertProductionComplete: attr({ getDefault: () => true }),
      alertAddSegments: attr({ getDefault: () => true }),
      alertDraftIntro: attr({ getDefault: () => true }),
      alertDraftImport: attr({ getDefault: () => true }),
      alertDraftGameBoard: attr({ getDefault: () => true }),
      alertDraftComparison: attr({ getDefault: () => true }),
      alertDraftComplete: attr({ getDefault: () => true }),
      alertAlignmentIntro: attr({ getDefault: () => true }),
      alertSimulateIntro: attr({ getDefault: () => true }),
      alertTournamentEntries: attr({ getDefault: () => true }),
      alertTournamentBrackets: attr({ getDefault: () => true }),
      alertCMSOverview: attr({ getDefault: () => true }),
      alertCMSImport: attr({ getDefault: () => true }),
      alertCMSCreate: attr({ getDefault: () => true }),
      alertImported: attr({ getDefault: () => true }),
      alertSaveLoadOverview: attr({ getDefault: () => true }),
      desc: attr({ getDefault: () => '' }),
      color: attr({ getDefault: () => '' }),
      backgroundColor: attr({ getDefault: () => '' })
    }
  }
  static reducer(action, Game, session) {
    let item
    switch (action.type) {
      case Types.TRIGGER_MIGRATION:
        const { transform, groupNames } = action.payload

        transform(session, groupNames)
        break
      case Types.GENERATE_GAMES:
        action?.payload?.forEach(newItem => {
          session.Game.upsert(newItem)
        })
        break
      case Types.RESET:
      case Types.RESET_GAME:
        Game.upsert({
          id: 1,
          pageId: 0,
          desc: '',
          brandIds: [],
          date: new Date()
        })
        break
      case Types.ADD_GAME:
        Game.upsert({
          id: 1,
          pageId: 0,
          desc: '',
          date: new Date()
        })
        break
      case Types.UPDATE_GAME:
        item = Game.withId(action.payload.id)
        if (item) {
          item.update(action.payload)
        }
        break
    }
  }
}

export default Game
